import React, { createContext, useState } from "react";
import { DoctorsDTO } from "../models/Doctors";
import { UserDTO } from "../models/User";

interface AuthContextType {
  loggedDoctor: DoctorsDTO | null;
  loggedUser: UserDTO | null;
  loginContext: (userData: DoctorsDTO) => void;
  logoutContext: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loggedDoctor, setLoggedDoctor] = useState<DoctorsDTO | null>(null);
  const [loggedUser, setLoggedUser] = useState<UserDTO | null>(null);

  const login = (doctorData: DoctorsDTO) => {
    setLoggedDoctor(doctorData);
    setLoggedUser(doctorData.user!); // a regime ci sarà sempre l'user
    // Qui potrebbe esserci un problema se usi useNavigate
    // const navigate = useNavigate();
    // navigate('/dashboard'); // Problema: questo deve avvenire all'interno del contesto di Router
  };

  const logout = () => {
    setLoggedDoctor(null);
    setLoggedUser(null);
    // Potresti voler spostare il reindirizzamento fuori da qui
  };

  return (
    <AuthContext.Provider
      value={{
        loggedDoctor,
        loggedUser,
        loginContext: login,
        logoutContext: logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
